import { createContext, useEffect, useState } from "react";
import { formatEther } from "viem";
import { useAccount, usePublicClient } from "wagmi";
import {
  AIRDROP_ADDRESS,
  AIRDROP_ABI,
  AIRDROP2_ADDRESS,
  AIRDROP3_ADDRESS,
} from "../lib/constants";

// initial state
const defaultValues = {
  airdropAmount: 0,
  nextClaim:0,
  totalAmount:0,
  withdrawn:0,
  airdropAmount2: 0,
  nextClaim2:0,
  totalAmount2:0,
  withdrawn2:0,
  airdropAmount3: 0,
  nextClaim3:0,
  totalAmount3:0,
  withdrawn3:0,
  getAirdrop: () => {},
};
// context
export const AirdropContext = createContext(defaultValues);

export const AirdropProvider = ({ children }) => {
  const publicClient = usePublicClient();
  const { address, isConnected } = useAccount();

  const [state, setAirdrop] = useState({
    airdropAmount: 0,
    nextClaim:0,
    totalAmount:0,
    withdrawn:0,
    airdropAmount2: 0,
    nextClaim2:0,
    totalAmount2:0,
    withdrawn2:0,
    airdropAmount3: 0,
    nextClaim3:0,
    totalAmount3:0,
    withdrawn3:0,
  });
 
  const getAirdrop = async (address) => {
    //try {
      const [airdropAmount, nextClaim, totalAmount, withdrawn,airdropAmount2, nextClaim2, totalAmount2, withdrawn2,airdropAmount3, nextClaim3, totalAmount3, withdrawn3] = await Promise.all([
        publicClient.readContract({
          abi: AIRDROP_ABI,
          address: AIRDROP_ADDRESS,
          functionName: "getAirdropAmount",
          args: [address],
        }),
        publicClient.readContract({
            abi: AIRDROP_ABI,
            address: AIRDROP_ADDRESS,
            functionName: "getNextClaim",
            args: [address],
          }),
          publicClient.readContract({
            abi: AIRDROP_ABI,
            address: AIRDROP_ADDRESS,
            functionName: "getTotalAmount",
            args: [address],
          }),
          publicClient.readContract({
            abi: AIRDROP_ABI,
            address: AIRDROP_ADDRESS,
            functionName: "getWithdrawn",
            args: [address],
          }),
          publicClient.readContract({
            abi: AIRDROP_ABI,
            address: AIRDROP2_ADDRESS,
            functionName: "getAirdropAmount",
            args: [address],
          }),
          publicClient.readContract({
              abi: AIRDROP_ABI,
              address: AIRDROP2_ADDRESS,
              functionName: "getNextClaim",
              args: [address],
            }),
            publicClient.readContract({
              abi: AIRDROP_ABI,
              address: AIRDROP2_ADDRESS,
              functionName: "getTotalAmount",
              args: [address],
            }),
            publicClient.readContract({
              abi: AIRDROP_ABI,
              address: AIRDROP2_ADDRESS,
              functionName: "getWithdrawn",
              args: [address],
            }),
          publicClient.readContract({
            abi: AIRDROP_ABI,
            address: AIRDROP3_ADDRESS,
            functionName: "getAirdropAmount",
            args: [address],
          }),
          publicClient.readContract({
              abi: AIRDROP_ABI,
              address: AIRDROP3_ADDRESS,
              functionName: "getNextClaim",
              args: [address],
            }),
            publicClient.readContract({
              abi: AIRDROP_ABI,
              address: AIRDROP3_ADDRESS,
              functionName: "getTotalAmount",
              args: [address],
            }),
            publicClient.readContract({
              abi: AIRDROP_ABI,
              address: AIRDROP3_ADDRESS,
              functionName: "getWithdrawn",
              args: [address],
            }),
      ]);

      setAirdrop({
        airdropAmount: formatEther(airdropAmount || "0"),
        nextClaim: nextClaim || "0",
        totalAmount: formatEther(totalAmount || "0"),
        withdrawn: formatEther(withdrawn || "0"),
        airdropAmount2: formatEther(airdropAmount2 || "0"),
        nextClaim2: nextClaim2 || "0",
        totalAmount2: formatEther(totalAmount2 || "0"),
        withdrawn2: formatEther(withdrawn2 || "0"),
        airdropAmount3: formatEther(airdropAmount3 || "0"),
        nextClaim3: nextClaim3 || "0",
        totalAmount3: formatEther(totalAmount3 || "0"),
        withdrawn3: formatEther(withdrawn3 || "0"),
      });


    //} catch (err) {}
    
  };

  useEffect(() => {
    isConnected && getAirdrop(address);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, isConnected]);

  return (
    <AirdropContext.Provider value={{ ...state, getAirdrop }}>
      {children}
    </AirdropContext.Provider>
  );
};
